import type {
  PaginationResponsiveUiType,
  PaginationSkin,
} from '../../Pagination.types';

const responsiveSkins: Array<PaginationResponsiveUiType> = [
  'ResponsivePagination',
];

export const isResponsiveSkin = (skin: PaginationSkin) => {
  const skinSuffix = skin.split('.').pop();
  return (
    responsiveSkins.includes(skin as PaginationResponsiveUiType) ||
    responsiveSkins.includes(skinSuffix as PaginationResponsiveUiType)
  );
};
